import stylefunction from 'ol-mapbox-style/dist/stylefunction';

export default stylefunction;
